import React, { useState, useEffect } from 'react';
import { Modal, Button, Upload, Icon, Progress } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { actionAddFileProductRequest, actionAddFileProductSuccess, actionDeleteFileProductRequest, actionGetFilesProduct } from '../../../store/acciones/accionesProductos';
import axios from 'axios'
import CONSTANTES from '../../../store/constantes';

function getBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});
}

const uploadButton = (
	<div>
		<Icon type="plus" />
		<div className="ant-upload-text">Upload</div>
	</div>
);

const ImageUpload = (props) => {
	const dispatch = useDispatch()
	const filesProducts = useSelector(state => state.reducerFileProduct.filesProduct);
	const [visible, setVisible] = useState(false)
	const [previewVisible, setPreviewVisible] = useState(false)
	const [previewImage, setPreviewImage] = useState('')
	const [imageObject, setImageObject]=useState(null)
	const [fileList, setFileList] = useState([])
	const [progress, setProgress] = useState(0);
	
	const handleCancel = () => setPreviewVisible(false);

	const handlePreview = async file => {
		if (!file.url && !file.preview) {
			file.preview = await getBase64(file.originFileObj);
		}
		setPreviewVisible(true)
		setPreviewImage(file.url || file.preview)
	};


	const handleChange = ({ file, fileList, event }) => {
		console.log(fileList)
		setFileList([...fileList])
	};

	const handleRemove = file => {
		axios
			.delete(`${CONSTANTES.URL_API}/sellers/image_products/${file.uid}/`)
			.then(res => {
				dispatch(actionDeleteFileProductRequest(file))
			})
			.catch(err => {
				console.log(err)
			});
	};

	const uploadImage = async options => {
		const { onSuccess, onError, file, onProgress } = options;
		const fmData = new FormData();
		const config = {
			headers: { "content-type": "multipart/form-data" },
			onUploadProgress: event => {
				const percent = Math.floor((event.loaded / event.total) * 100);
				setProgress(percent);
				if (percent === 100) {
					setTimeout(() => setProgress(0), 1000);
				}
				onProgress({ percent: (event.loaded / event.total) * 100 });
			}
		};
		fmData.append("image_product", file);
		fmData.append("producto", props.product.id);
		try {
			await axios.post(
				`${CONSTANTES.URL_API}/sellers/image_products/`,
				fmData,
				config
			).then(res => {
				if (res.data) {
					const data = res.data
					dispatch(actionAddFileProductSuccess({ name: data.producto, status: "done", uid: data.id, url: data.image_product }))
				}
			})
		} catch (err) {
			const error = new Error("Some error");
			onError({ err });
		}
	};

	const handlePreviwmage = (url) => {
		const extension = url.split('.').pop()
		console.log(extension)
		if (extension === "pdf") {
			return <div style={{height:200, display:"flex", justifyContent:"center", alignItems:"center"}}>
					<a href={url} target="blank" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
						<Icon
							type="file-pdf"
							style={{ fontSize: '80px', color: '#a20a0a' }} />
					</a>
			</div>
		}
		else{
			return <img alt="example" style={{ width: '100%' }} src={url} />
		}
	}

	useEffect(() => {
		dispatch(actionGetFilesProduct(props.product.id))
	}, [dispatch])

	
	return (
		<div>
			<Button type="primary" icon="upload" onClick={() => setVisible(true)}>
				Upload
			</Button>
			<Modal
				title="ImageProduct"
				visible={visible}
				onOk={() => setVisible(false)}
				onCancel={() => setVisible(false)}
			>
				<div style={{ width: "100%" }}>
					<Upload
						//action={onUpload}
						accept="image/*, .pdf"
						customRequest={uploadImage}
						listType="picture-card"
						fileList={filesProducts}
						onPreview={handlePreview}
						onChange={handleChange}
						onRemove={handleRemove}
					>
						{filesProducts.length >= 8 ? null : uploadButton}
					</Upload>
					{progress > 0 ? <Progress percent={progress} /> : null}
					<Modal visible={previewVisible} footer={null} onCancel={handleCancel}>
						{/* <img alt="example" style={{ width: '100%' }} src={previewImage} /> */}
						{handlePreviwmage(previewImage)}
					</Modal>
				</div>

			</Modal>

		</div>
	);
};

export default ImageUpload;